import {
  hasStringValue,
  isSelected,
  isMin,
  maxLengthNotExceeding,
  correctEmail,
  hasMinLength,
  correctPhoneNumber
} from "@utilities";

const basicBusiness = [

  {
    field: "clientProfile.0.data.clientServicesDescription",
    validation: hasStringValue
  },
  {
    field: "clientProfile.0.data.requireBusinessLicense",
    validation: isSelected
  },
  {
    field: "clientProfile.0.data.amlRulesLeg",
    validation: isSelected
  }
];

const basicBusinessIncome = [
  {
    field: "clientBasicBusiness.0.data.yearlyIncome",
    validation: hasStringValue
  },
  {
    field: "clientBasicBusiness.0.data.yearlyIncome",
    validation: isMin(0)
  },
  {
    field: "clientProfile.0.data.balAsst",
    validation: hasStringValue
  },
  {
    field: "clientProfile.0.data.balAsst",
    validation: isMin(0)
  },
  {
    field: "clientProfile.0.data.clientEmployeeQty",
    validation: hasStringValue
  },
  {
    field: "clientProfile.0.data.clientEmployeeQty",
    validation: isMin(0)
  },
  {
    field: "clientProfile.0.data.clientSize",
    validation: hasStringValue
  }
];

const businessLicense = [
  {
    field: "clientProfile.0.data.businessLicenseNumber",
    validation: hasStringValue
  }
];

const amlRulesLeg = [
  {
    field: "clientProfile.0.data.amlProcedure",
    validation: isSelected
  },
  {
    field: "clientProfile.0.data.amlCheckInSancLis",
    validation: hasStringValue
  },
  {
    field: "clientProfile.0.data.amlOfficerEmail",
    validation: hasStringValue
  },
  {
    field: "clientProfile.0.data.amlOfficerEmail",
    validation: correctEmail
  },
  {
    field: "clientProfile.0.data.amlOfficerNameSur",
    validation: hasStringValue
  },
  {
    field: "clientPhone.0.data.amlOfficerPhone",
    validation: hasStringValue
  },
  {
    field: "clientPhone.0.data.amlOfficerPhone",
    validation: correctPhoneNumber
  },
  {
    field: "clientPhone.0.data.amlOfficerPhone",
    validation: hasMinLength(8)
  },
  {
    field: "clientPhone.0.data.amlOfficerPhone",
    validation: maxLengthNotExceeding(20)
  }
];

export const getStep6Validations = ({ requiredBusinessLicense, requiredAmlRulesLeg }) => [
  ...basicBusiness,
  ...basicBusinessIncome,
  ...(requiredBusinessLicense === true ||
  requiredBusinessLicense === "1" ||
  requiredBusinessLicense === 1
    ? businessLicense
    : []),
  ...(requiredAmlRulesLeg === true || requiredAmlRulesLeg === "1" || requiredAmlRulesLeg === 1
    ? amlRulesLeg
    : [])
];
